import { Space, Typography, theme } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';

const { Text } = Typography;

export interface EmptyStateProps {
  title?: string;
  description?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({ title, description, action, compact = false }: EmptyStateProps) {
  const { token } = theme.useToken();
  return (
    <div
      data-testid="empty-state"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: compact ? '24px 16px' : '40px 24px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 14,
          background: token.colorFillTertiary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
          color: token.colorTextTertiary,
          fontSize: 26,
        }}
      >
        <InboxOutlined />
      </div>
      <Space orientation="vertical" size={6} align="center">
        {title && (
          <Text strong style={{ fontSize: 14, color: token.colorText }}>
            {title}
          </Text>
        )}
        {description && (
          <Text type="secondary" style={{ fontSize: 13, maxWidth: 360 }}>
            {description}
          </Text>
        )}
        {action && <div style={{ marginTop: 8 }}>{action}</div>}
      </Space>
    </div>
  );
}
